import { render, staticRenderFns } from "./ChallengeStartButton.vue?vue&type=template&id=6f647512"
import script from "./ChallengeStartButton.vue?vue&type=script&lang=js"
export * from "./ChallengeStartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports